window.Date.now = function now() {
  return new window.Date().getTime()
}
